import React from 'react';
import { Link } from 'gatsby';
import moment from 'moment';

import Asset from '@src/components/Asset';

export default function RelatedEventsList(props) {
    const { data } = props;
    const events = data.eventsList;

    if (events.length < 1) return null;

    return (
        <div className="relative spacing border-top border-top--dashed">
            <h6 className="h6 mb-18px">Related</h6>
            <div className="grid grid--3 relative">
                {events.map((entry, i) => (
                    <div key={entry.id}>
                        {entry.singleImage[0] ? (
                            <div className="mb-8px">
                                <Link to={`/${entry.uri}`}>
                                    <Asset
                                        data={entry.singleImage[0].imageFile}
                                        title={entry.singleImage[0].title}
                                    />
                                </Link>
                            </div>
                        ) : null}
                        <Link to={`/${entry.uri}`} className="link">
                            <h6 className="h6 m-0">{entry.title}</h6>
                            <p>{moment(entry.eventDate).format('MMM D, Y')}</p>
                            <p>{entry.plainText}</p>
                        </Link>
                    </div>
                ))}
            </div>
        </div>
    );
}
